import { render, staticRenderFns } from "./ClassifyDocuments.vue?vue&type=template&id=48e2ab96&scoped=true"
import script from "./ClassifyDocuments.vue?vue&type=script&lang=js"
export * from "./ClassifyDocuments.vue?vue&type=script&lang=js"
import style0 from "./ClassifyDocuments.vue?vue&type=style&index=0&id=48e2ab96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e2ab96",
  null
  
)

export default component.exports